module.exports = __webpack_public_path__ + "static/img/logoKDCA-white.f485072.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoKDCA-white.svg
// module id = 56GT
// module chunks = 1